export default __webpack_public_path__ + "static/media/email-black.0beee188.svg";